export const tableColumns = [
  { id: 'checkbox', headerWidth: 0, width: 16, height: 16, isIcon: true },
  { id: 'hasAlert', headerWidth: 0, width: 16, height: 16, isIcon: true },
  { id: 'order', headerWidth: 60, width: 100, height: 16 },
  { id: 'status', headerWidth: 60, width: 80, height: 24 },
  { id: 'creationDate', headerWidth: 100, width: 90, height: 16 },
  { id: 'lastUpdate', headerWidth: 100, width: 90, height: 16 },
  { id: 'sender', headerWidth: 80, width: 120, height: 16 },
  { id: 'recipient', headerWidth: 90, width: 120, height: 16 },
  { id: 'origin', headerWidth: 60, width: 100, height: 16 },
  { id: 'destination', headerWidth: 60, width: 100, height: 16 },
  { id: 'carrier', headerWidth: 90, width: 100, height: 16 },
  { id: 'products', headerWidth: 70, width: 60, height: 16 },
  { id: 'tracking', headerWidth: 90, width: 120, height: 16 },
  { id: 'pickupDate', headerWidth: 70, width: 90, height: 16 },
]
